import { Navigate } from 'react-router-dom'
import { clearAuthData, isTokenExpired } from '../services/authStorage'

const ProtectedRoute = ({ children }) => {
	const token = localStorage.getItem('authToken')

	if (!token) {
		return <Navigate to="/login" replace />
	}

	if (isTokenExpired()) {
		clearAuthData()
		return <Navigate to="/login" replace />
	}

	return children
}

export default ProtectedRoute
